module.exports = __webpack_public_path__ + "static/media/cultureOfUzbekistan.ac94bc3c.png";